import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DynamicFieldConfig, UiField } from '../../../core/models/dynamic-form.models';
import { DynamicFieldService } from '../../../core/services/dynamic-field.service';
import { DynamicAutocompleteComponent } from '../../../partials/components/dynamic-autocomplete/dynamic-autocomplete';
import { SWDynamicAutocompleteComponent } from '../../../partials/components/sw-autocomplete/sw-autocomplete.component';
import { FieldHostComponent } from '../../../core/runtime/host/field-host.component';
// import { TranslationService } from '../../../core/services/translation.service';
// import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-dynamic-field',
  standalone: true,
  // changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, 
    ReactiveFormsModule, 
    FormsModule, 
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DynamicAutocompleteComponent,
    MatFormField,
    SWDynamicAutocompleteComponent,
    FieldHostComponent
//   TranslatePipe // IMPORTED PIPE
  ],
  templateUrl: './dynamic-field.html'
})
export class DynamicFieldComponent {
  @Input() field!: UiField;
  @Input() config!: DynamicFieldConfig;
  @Input() form!: FormGroup;
  @Input() row!: any;

  constructor(private dfs: DynamicFieldService) {}

  // get control() {
  //   return this.form.get(this.config.name);
  // }
  get isVisible(): boolean {
  return this.dfs.isVisible(this.config.name);
}

  // onSelectChange(value: any) {
  //   const events = this.config.events || [];
  //   events
  //     .filter(e => e.active && e.label === 'optionSelected')
  //     .forEach(ev => {
  //       this.dfs.fireEvent(this.config.name, ev.label, { value, handler: ev.value });
  //     });
  // }
}
